import { useState } from "react";
import { CalendarInput } from "@etframework/ui.components";
import { CalendarDropDown } from "./CalendarDropDown";
import { useCalendarTasks } from "../../hooks/useCalendarTasks";
import { useTranslation } from "react-i18next";
import useEvent from "../../hooks/useEvent";
import moment from "moment";
import taskService from "../../data/api/taskService";

export const CalendarContainer = ({ id, currentBoardId }) => {
  const { t, i18n } = useTranslation(["RightPanel"]);

  const [selectedDate, setSelectedDate] = useState(moment().toDate());

  const { Events, toggleEvent } = useEvent();
  const { getTaskByDay } = taskService();

  // Updated to pass `currentBoardId` as a dependency
  const { pendingTasks, completedTasks } = useCalendarTasks(
    selectedDate,
    onTaskClick,
    currentBoardId
  );

  function onChange(e) {
    setSelectedDate(e);
  }

  function onTaskClick(taskId) {
    toggleEvent(Events.TaskOverlay, { taskId });
  }

  const handleGetSpecialDates = (month, year) => {
    if (currentBoardId) {
      return new Promise((resolve, reject) => {
        const from = moment()
          .year(year)
          .month(month)
          .startOf("month")
          .toISOString();

        const to = moment()
          .year(year)
          .month(month)
          .endOf("month")
          .toISOString();

        getTaskByDay(currentBoardId, from, to)
          .then((res) => {
            const duedates = res.data?.map?.((task) => ({
              date: moment(task.DueDate).toDate(),
              type: "experttax-blue",
            }));

            resolve(duedates);
          })
          .catch((e) => reject(e));
      });
    }
  };

  return (
    <div className="et-right-panel-wrapper d-flex flex-column gap-3">
      <CalendarInput
        id={id}
        change={onChange}
        showTodayButton={false}
        locale={i18n.language}
        specialDates={handleGetSpecialDates}
      />
      <div className="et-calendar-drop-down-wrapper d-flex flex-column gap-3">
        <CalendarDropDown
          {...(id ? { id: `${id}_pending-task-list` } : {})}
          defaultOpen={true}
          detailList={pendingTasks}
          title={t("PendingTasks", { count: pendingTasks.length })}
          taskCount={pendingTasks.length}
          emptyMessage={t("InProgressEmptyState")}
        />
        <CalendarDropDown
          {...(id ? { id: `${id}_completed-task-list` } : {})}
          detailList={completedTasks}
          title={t("CompletedTasks", { count: completedTasks.length })}
          taskCount={completedTasks.length}
          emptyMessage={t("CompletedEmptyState")}
        />
      </div>
    </div>
  );
};
